import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10","key":"svg-0"}],["path",{"d":"M7 15v-4.5a1.5 1.5 0 0 1 3 0v4.5","key":"svg-1"}],["path",{"d":"M7 13h3","key":"svg-2"}],["path",{"d":"M14 12h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6m3 0l-2 -3","key":"svg-3"}]]

const IconBadgeAr = createReactComponent('outline', 'badge-ar', 'BadgeAr', __iconNode);

export default IconBadgeAr;